import { Component, OnInit, Input } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { MenuItems } from '../../../../Core/Menu/MenuItems/MenuItems';
import { AuthService } from 'src/app/Services/Auth/auth.service';
import { LevelService } from 'src/app/Services/level.service';

@Component({
   selector: 'app-header-menu',
   templateUrl: './HeaderMenu.component.html',
   styleUrls: ['./HeaderMenu.component.scss']
})

export class MenuComponent implements OnInit {

   @Input() stickyClass: any;
   currentUrl: any;
   items: any;

   constructor(public menuItems: MenuItems,
      private router: Router,
      private authService: AuthService,
      private levelService: LevelService) { }

   ngOnInit() {
      this.currentUrl = this.router.url;
      if (this.authService.isAuthenticated()) {
         this.items = this.menuItems.getAuthMenu();
      } else {
         this.items = this.menuItems.getMainMenu();
         this.loadLevelsDropdown();
      }
      //header responsive
      if ((this.currentUrl != '/session/comingsoon') && (this.currentUrl != '/session/maintenance')
      ) {
         var menuItems = document.getElementsByClassName('menu-item-has-child')
         for (var i = 0; i < menuItems.length; i++) {
            (function (index) {
               menuItems[index].addEventListener("click", function (event) {
                  event.stopPropagation();
                  if (menuItems[index] != undefined) {
                     menuItems[index].classList.toggle('opened-submenu');
                  }
               })
            })(i);
         }
         this.router.events.subscribe((val) => {
            if (val instanceof NavigationEnd) {
               this.currentUrl = this.router.url;
               if (this.currentUrl == '/home') {
                  window.scrollTo({ top: 0, behavior: 'smooth' })
               }
            }
         })
      }



   }

   /**
    * Populate the "Niveles" dropdown with the public levels.
    * Each child links to /level-profile/:id (handled by the sub-menu template).
    */
   private async loadLevelsDropdown(): Promise<void> {
      const nivelesItem = (this.items || []).find((item: any) => item.type === 'sub' && item.state === 'level-profile');
      if (!nivelesItem) {
         return;
      }
      try {
         const res = await this.levelService.getLevels();
         const list = res?.data?.data;
         if (Array.isArray(list)) {
            nivelesItem.children = list.map((level: any) => ({
               state: String(level.id),
               name: level.name,
               type: 'link',
            }));
         }
      } catch {
         // Keep the dropdown empty on failure; the rest of the menu still works.
      }
   }
}
